import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DsraEventListSF from '../../../components/superUser/loan/repayment/DsraEventListSF'

const DsraPageUI = ({ context, errorList, account, loan, onRefreshClick,
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_dsra_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !account} loan={loan} page='dsra'
  >
    {
      (!loan || !errorList || !account) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>DSRA</b></span>
            </span>
          }
          right={<span />}
        />

        {
          // repaymentList && 
          loan.sanction.dsraAmountF2 &&
          <DsraUI context={context} account={account} loan={loan}
            onRefreshClick={onRefreshClick}
          />
        }
        {
          !loan.termSheet.amountF2 && !loan.sanction.amountF2 &&
          <div className='g_m_left_100'>No amortization or repayments yet</div>
        }
      </div>
    }
  </SuperUserLoanPageSF>

const DsraUI = ({ context, account, loan, onRefreshClick,
}) =>
  <div className='g_flex_v c_dsr'>
    <CardUI title='DSRA status' className='g_m_bottom_100'>
      <div className='g_flex_top g_flex_h g_flex_left'>
        <LabelAndValueUI label='DSRA'>{loan.sanction.dsraAmountF2}</LabelAndValueUI>
        <LabelAndValueUI className='g_m_left_100' label='Current'>{loan.penalty.dsraCurrentF1}</LabelAndValueUI>
        <LabelAndValueUI className='g_m_left_100' label='Dipped'>{loan.penalty.dsraDippedF1}</LabelAndValueUI>
        <LabelAndValueUI className='g_m_left_100' label='Dipped date'>{loan.penalty.dsraDippedDateF1}</LabelAndValueUI>
        <LabelAndValueUI className='g_m_left_100' label='Restore date'>{loan.penalty.dsraRestoreDateF1}</LabelAndValueUI>
      </div>
    </CardUI>

    <DsraEventListSF
      context={context}
      loan={loan} account={account}
      onRefreshClick={onRefreshClick}
    />
  </div>

export default DsraPageUI
